import { render, staticRenderFns } from "./ShiftsListPopup.vue?vue&type=template&id=876d9cd0"
import script from "./ShiftsListPopup.vue?vue&type=script&lang=ts"
export * from "./ShiftsListPopup.vue?vue&type=script&lang=ts"
import style0 from "./ShiftsListPopup.vue?vue&type=style&index=0&id=876d9cd0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports